import { gql } from "@apollo/client";

export const LOADOUT_QUERY = gql`
  query Loadouts($game: Int!, $type: String!) {
    loadouts(game: $game, type: $type) {
      _id
      name
      description
      image
      cards {
        _id
      }
    }
  }
`;

const PLAYER_USER_FIELDS = gql`
  fragment PlayerUserFragment on User {
    _id
    username
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      mediaUploadUrl(type: JPEG) {
        fields {
          name
          value
        }
        key
        url
      }
    }
  }
`;

export const QUICK_EDIT_IN_CAMPAIGN = gql`
  query QuickEditInCampaign($campaign: String) {
    inCampaign(campaign: $campaign) {
      exists
      progress
    }
  }
`;

export const QUICK_EDIT_GET_MOMENT = gql`
  ${PLAYER_USER_FIELDS}
  query QuickEditGetMoment($id: String!) {
    moment(id: $id) {
      id
      title
      timelineLabel
      game
      type
      match {
        id
        matchPlayedAt
      }
      victimData {
        team
        gameId
        displayName
        avatar
        user {
          ...PlayerUserFragment @nonreactive
        }
      }
      clip {
        id
      }
      icons
      player {
        avatar
        displayName
        gameId
        team
        user {
          ...PlayerUserFragment @nonreactive
        }
      }
    }
  }
`;

export const THUMBNAIL_QUERY = gql`
  query FacetQuery($type: [String], $option2: Boolean) {
    facets(type: $type, option2: $option2) {
      cards {
        _id
        ui {
          image
        }
      }
    }
  }
`;

export const GET_LOADOUTS = gql`
  query GetLoadouts($game: Int) {
    loadouts(game: $game) {
      name
    }
  }
`;
